const DEPOSIT_ACTION = Object.freeze({
  bankDeposit: 'BANK_DEPOSIT',
  bankCharges: 'BANK_CHARGES',
  keep: 'keep-in-user-account',
  refund: 'REFUND',
});

// noinspection JSUnusedGlobalSymbols
export default DEPOSIT_ACTION;
